import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import AuthContext from './context/AuthContext';
import ClientContext from './context/ClientContext';
import DispatchedDevicesContext from './context/DispatchedDevicesContext';
import MqttProvider from './mqtt/MqttConnection.js'
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import RoleProtectedRoute from './utils/RoleProtectedRoute.jsx';
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
  <AuthContext>
  <ClientContext>
  <DispatchedDevicesContext>
  <MqttProvider>
   <App />
  </MqttProvider>
  </DispatchedDevicesContext>
  </ClientContext>
  </AuthContext>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
